import { render, staticRenderFns } from "./afterSalesStatistic.vue?vue&type=template&id=0d803d35&scoped=true"
import script from "./afterSalesStatistic.vue?vue&type=script&lang=js"
export * from "./afterSalesStatistic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d803d35",
  null
  
)

export default component.exports